
import SharedLayout from './SharedLayout.vue';

export default {
  name: 'NoWidgetLayout',
  components: { SharedLayout },
};
